import { JsonApiQuery } from '@nx-icilalune/data/access';
import {
  BusinessUnitTerm,
  Client,
  Project,
} from '@nx-icilalune/data/icilalune/types';
import {
  allParagraphIncludes,
  associatedProjectsIncludes,
  projetRelationAttributeEnhancers,
} from './icilalune.queries';
import { ImageMedia } from '@nx-icilalune/drupal-types';

const projectListIncludes = ['client', 'thumbnail', 'business_unit'];
export const projectListQuery: JsonApiQuery = {
  queryId: 'projectListQuery',
  type: Project.type,
  page: {
    limit: 10,
    offset: 0,
  },
  fields: {
    [Project.type]: [
      'title',
      'client',
      'thumbnail',
      'path',
      'langcode',
      'business_unit',
    ],
    [Client.type]: ['title', 'langcode', 'path'],
    [BusinessUnitTerm.type]: ['name'],
    [ImageMedia.type]: ['fileRef', 'langcode'],
  },
  relationAttributeEnhancers: [...projetRelationAttributeEnhancers],
  include: projectListIncludes,
  sort: [{ field: 'project_start', direction: 'DESC' }],
  editable: true,
  paging: true,
  filters: {
    isPublished: '1',
  },
};
const projectIncludes = [
  ...projectListIncludes,
  'media',
  ...allParagraphIncludes,
  'client.logo.fileRef',
  ...associatedProjectsIncludes,
];
export const projectDetailQuery: JsonApiQuery = {
  queryId: 'projectDetailQuery',
  type: Project.type,
  relationAttributeEnhancers: [...projetRelationAttributeEnhancers],
  include: projectIncludes,
};
